











































































































































import _ from 'lodash'
import confirmMixin from '@/modules/common/mixins/confirmMixin'
import Component, { mixins } from 'vue-class-component'
import { contactTypes } from '@/modules/pass/types/contactType'
import move from 'lodash-move'
import notificationService from '@/modules/common/services/notificationService'
import page from '@/modules/common/components/page.vue'
import { Prop } from 'vue-property-decorator'
import Pass from '@/modules/pass/domain/pass'
import selectField from '@/modules/common/components/form/selectField.vue'
import textAreaField from '@/modules/common/components/form/textAreaField.vue'
import textField from '@/modules/common/components/form/textField.vue'
import validationMixin from '@/modules/common/components/form/validationMixin'
import vForm from '@/modules/common/components/form/vForm.vue'
import Contact from '@/modules/pass/domain/contact'
import PassSection from '@/modules/pass/domain/passSection'
import EntityCreateParams from '@/modules/common/store/entityCreateParams'

@Component({
  components: { page, selectField, textAreaField, textField, vForm }
})
export default class PassForm extends mixins(validationMixin, confirmMixin) {
  contactTypes = contactTypes

  @Prop({ type: Pass, required: true }) model!: Pass

  onSubmit () {
    this.$store.dispatch('pass/update', new EntityCreateParams(this.model, false)).then((result: Pass) => {
      if (result) {
        notificationService.success('data.edit.success')
        this.$router.push('/pass')
      }
    }).finally(this.unprotect)
  }

  addContact () {
    this.model.draft!.contacts.push(new Contact())
  }

  addSection () {
    this.model.draft!.sections.push(new PassSection())
  }

  deleteSection (section: PassSection) {
    this.model.draft!.sections = _.without(this.model.draft!.sections, section)
  }

  sectionPositionDown (section: PassSection) {
    const sectionIndex = this.model.draft!.sections.indexOf(section)
    const indexOfNextItem = sectionIndex + 1
    // last index check
    if (this.model.draft!.sections.length <= indexOfNextItem) {
      return
    }

    this.model.draft!.sections = move(this.model.draft!.sections, sectionIndex, indexOfNextItem)
  }

  sectionPositionUp (section: PassSection) {
    const sectionIndex = this.model.draft!.sections.indexOf(section)
    const indexOfPrevItem = sectionIndex - 1
    // first index check
    if (indexOfPrevItem < 0) {
      return
    }
    this.model.draft!.sections = move(this.model.draft!.sections, sectionIndex, indexOfPrevItem)
  }

  deleteContact (contact: Contact) {
    this.model.draft!.contacts = _.without(this.model.draft!.contacts, contact)
  }

  contactPositionDown (contact: Contact) {
    const contactIndex = this.model.draft!.contacts.indexOf(contact)
    const indexOfNextItem = contactIndex + 1
    // last index check
    if (this.model.draft!.contacts.length <= indexOfNextItem) {
      return
    }

    this.model.draft!.contacts = move(this.model.draft!.contacts, contactIndex, indexOfNextItem)
  }

  contactPositionUp (contact: Contact) {
    const contactIndex = this.model.draft!.contacts.indexOf(contact)
    const indexOfPrevItem = contactIndex - 1
    // first index check
    if (indexOfPrevItem < 0) {
      return
    }
    this.model.draft!.contacts = move(this.model.draft!.contacts, contactIndex, indexOfPrevItem)
  }
}
